/**
 * Created by ievgenb on 9/28/2016.
 */
define(function(require) {
    'use strict';

    var PromotionModel = require('common/base.model');
    var virtueFusionService = require('modules/services/vf.service');
    var $ = require('j');
    var server = require('server');

    var BingoPromocodeModel = PromotionModel.extend({

        /**
         * Register Virtue Fusion promo code
         * @public
         * @return {Deferred}
         * */
        registerPromocode: function() {
            this.request = $.Deferred();

            virtueFusionService.registerPromoCode({
                promoCode: this.get('promotionCode')
            })
            .done(this._handleSuccessResponse.bind(this))
            .fail(this._delegateResponse.bind(this));

            return this.request.promise();
        },

        /**
         * Register IMS promo code
         * @public
         * @return {Deferred}
         * */
        registerPromoCodeIMS: function() {
            return server.send({
                ID: 31065,
                description: 'Apply promo code',
                responses: [31066, 31067],
                promotionCode: this.get('promotionCode'),
                triggerType: 'PromotionCode'
            })
                .done(this._handleSuccessResponse.bind(this))
                .fail(this._handleErrorResponse.bind(this));
        },

        _delegateResponse: function(response) {
            response.data.errorCode ? this.registerPromoCodeIMS() : this._handleErrorResponse(response);
        },

        _handleSuccessResponse: function(response) {
            this.request.resolve(response);
        },

        _handleErrorResponse: function(err) {
           this.request.reject(err);
        }
    });

    return BingoPromocodeModel;
});
